import React, { use, useState } from "react";

import "./suggestionSearch.css";
import { shuffle } from "../utils/arrayUtils";
const MAX_ELEMENTS = 7;

interface SuggestionSearchProps {
    onSearch: (v: string) => void;
    options: string[];
    onEnter: (v: string) => void;
    placeholder?: string;
    maxLength?: number;
    showOnFocus?: boolean;
    shuffle?: boolean;
}

export default function SuggestionSearch(props: SuggestionSearchProps) {

    const [search, setSearch] = useState("");
    const [focus, setFocus] = useState(false);
    var count = 0;

    var options = props.options;
    if(!options.includes(search)) {
        options = [...props.options, search];
    }

    if(props.shuffle) {
        shuffle(options);
    }

    return <div className="suggestion-search">
        <input onFocus={() => {
            setFocus(true);
        }} onBlur={() => {
            setTimeout(() => {
                setFocus(false);
            }, 100);
        }} onKeyUp={(e) => {
            if(e.key === "Enter") {
                props.onEnter(search);
                setSearch("");
            }
        }} value={search} placeholder={props.placeholder} className="search-bar" type="text" onChange={(e) => {
            if(e.target.value.length > (props.maxLength ? props.maxLength : 50)) return;
            if(e.target.value.length == 0) {
                setSearch("");
                props.onSearch("");
                return;
            }
            if(e.target.value.includes("\n")) return;
            if(e.target.value.includes("\r")) return;
            if(e.target.value.includes("\t")) return;
            props.onSearch(e.target.value);
            setSearch(e.target.value);
        }}/>
        <div className="suggestions">
            {options.map((e, i) => {
                if(props.showOnFocus) {
                    if(!focus) return;
                }else {
                    if(search.trim().length == 0) return;
                }
                if(!e.toLowerCase().includes(search.trim().toLowerCase())) return;
                if(e.trim().length == 0) return;
                if(count++ >= MAX_ELEMENTS) return;
                return <div onClick={() => {
                    props.onEnter(e);
                    setSearch("");
                }} className="option"><a>+ {e}</a></div>;
            })}
        </div>
    </div>
}